module.exports = __webpack_public_path__ + "img/GERA_Ref3_3.jpg";